<script setup>
import {defineProps} from "vue";

const props = defineProps({
    content: Object,
});
</script>

<template>
    <div class="mt-2 mb-3 flex space-x-2">
        <div class="items-center rounded bg-slate-100 px-3 py-2 text-center">
            <h4 class="font-bold leading-tight text-blue-500">{{ props.content.quest_count }}</h4>
            <p class="text-xs text-slate-400">
                {{ $tt('content_card__details_path_content', props.content.quest_count) }}
            </p>
        </div>
    </div>
</template>
